export const selectUsersOnlineStatus = (state: IState) => state.users.usersOnlineStatus
